<template>
  <div  v-show="hideshow" :class="isPosition?'bottom':''">
    <slot></slot>
    <p class="agreement">注册或登录，即代表您已阅读并同意<br />
      <router-link :to="{ name: 'Agreement' }">《服务协议》</router-link>和
      <router-link :to="{ name: 'Privacy' }">《隐私政策》</router-link>
    </p>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      docmHeight: document.documentElement.clientHeight,  //默认屏幕高度
      showHeight: document.documentElement.clientHeight,   //实时屏幕高度
      hideshow:true,  //显示或者隐藏footer
      isPosition: false,
    }
  },
  watch: {
    showHeight:function() {
      if(this.docmHeight > this.showHeight){
        this.hideshow=false
      }else{
        this.hideshow=true
      }
    }
  },
  computed: mapState(['config']),
  mounted() {
    // window.onresize监听页面高度的变化
    window.onresize = ()=>{
      return(()=>{
        this.showHeight = document.body.clientHeight;
      })()
    }
    var clientHeight = document.body.clientHeight||document.documentElement.clientHeight;
    var parentHeight = document.getElementById("login-page").offsetHeight;
    if(parentHeight<clientHeight){
      this.isPosition = true
    }
  },
}
</script>
<style scoped lang="scss">
.agreement {
  padding-bottom: 30px;
  text-align: center;
  font-weight:400;
  font-size: 26px;
  color: #666;
  line-height: 42px;
  a {
    color: $theme_color;
  }
}
.bottom {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%
}
</style>
